import { Reveal } from "../components/Reveal";
import { Icon } from "../components/Icon";
import { PageHeader } from "../components/shared/PageHeader";
import { CTASection } from "../components/shared/CTASection";
import { INDUSTRIES, IMAGES } from "../data/content";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader
        testId="industries-header"
        eyebrow="Industries Served"
        title="Partners across the entire aviation ecosystem."
        subtitle="From global airlines to emerging startups and government-related bodies, we tailor our advisory to the realities of each organization we serve."
        image={IMAGES.tower}
      />

      <section className="bg-background py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-px overflow-hidden rounded-3xl border border-border bg-border sm:grid-cols-2 lg:grid-cols-4">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.title} delay={(i % 4) * 0.05} className="bg-white">
                <div data-testid={`industry-${i}`} className="group h-full p-8 transition-colors hover:bg-secondary/60">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 text-brand transition-transform group-hover:-translate-y-1">
                    <Icon name={ind.icon} className="h-6 w-6" />
                  </span>
                  <h3 className="mt-6 font-display text-lg font-bold text-navy">{ind.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{ind.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
